/* index.js */

"use strict";

const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;

module.exports = {
    checkboxFormatter,
    typeFormatter,
    deleteButtonFormatter,
};

function checkboxFormatter(row, cell, value /*, columnDef, dataContext*/) {
    let checkbox = document.createElement("div");
    if (value) {
        checkbox = document.createElement("base-icon-gl");
        checkbox.dataset.icon = "common.check";
        checkbox.setDarkTheme(true);
    }
    return checkbox.outerHTML;
}

function typeFormatter(row, cell, value, columnDef, dataContext) {
    if (value) {
        const typeObj = dataContext.typeOpts.find((val) => val.value === value);
        if (typeObj) {
            return typeObj.label;
        }
    }
    return "";

    // return _.get(dataContext, 'typeOpts' )value || "";
}

function deleteButtonFormatter(row, cell, value, columnDef, dataContext) {
    const elem = document.createElement("div");
    elem.classList.add("grid-actions");
    const editBtn = new ButtonControl({
        label: "Edit",
        darkTheme: true,
        disabled: dataContext.readOnly,
    });
    const editBtnElem = editBtn.renderer.getRootElement();
    editBtnElem.dataset.uuid = dataContext.id;
    editBtnElem.dataset.typeName = dataContext.type;
    editBtnElem.dataset.action = dataContext.readOnly ? "editdisabled" : "edit";

    elem.appendChild(editBtnElem);

    const button = new ButtonControl({
        label: "Delete",
        darkTheme: true,
        disabled: dataContext.readOnly,
    });
    const deleteBtnElem = button.renderer.getRootElement();
    deleteBtnElem.setAttribute("aria-label", `delete ${dataContext.name}`);
    deleteBtnElem.setAttribute("role", "button");
    deleteBtnElem.dataset.uuid = dataContext.id;
    deleteBtnElem.dataset.action = dataContext.readOnly ? "deletedisabled" : "delete";
    elem.appendChild(deleteBtnElem);

    return elem.outerHTML;
}
